import pedigreePerson from './pedigreePerson'
import { GENDER } from '../../constants'

const malePerson = { ...pedigreePerson, gender: GENDER.male }
const femalePerson = { ...pedigreePerson, gender: GENDER.female }
const unknownPerson = { ...pedigreePerson, gender: GENDER.unknown }

// This object represents the minimum data needed to display a
// 5 generation print-and-share pedigree.
export default Object.freeze({
  // Note: It appears that there is only ever one object in this array.
  pairings: [
    {
      childPedigrees: [
        {
          person: unknownPerson, // The SELECTED person's child
        },
      ],
      spousePedigree: {
        person: unknownPerson, // The SELECTED person's preferred spouse
      },
    },
  ],
  parents: {
    parent1Pedigree: {
      parents: {
        parent1Pedigree: {
          parents: {
            parent1Pedigree: {
              parents: {
                parent1Pedigree: {
                  person: malePerson, // 5th generation
                },
                parent2Pedigree: {
                  person: femalePerson, // 5th generation
                },
              },
              person: malePerson, // 4th generation
            },
            parent2Pedigree: {
              parents: {
                parent1Pedigree: {
                  person: malePerson, // 5th generation
                },
                parent2Pedigree: {
                  person: femalePerson, // 5th generation
                },
              },
              person: femalePerson, // 4th generation
            },
          },
          person: malePerson, // 3rd generation
        },
        parent2Pedigree: {
          parents: {
            parent1Pedigree: {
              parents: {
                parent1Pedigree: {
                  person: malePerson, // 5th generation
                },
                parent2Pedigree: {
                  person: femalePerson, // 5th generation
                },
              },
              person: malePerson, // 4th generation
            },
            parent2Pedigree: {
              parents: {
                parent1Pedigree: {
                  person: malePerson, // 5th generation
                },
                parent2Pedigree: {
                  person: femalePerson, // 5th generation
                },
              },
              person: femalePerson, // 4th generation
            },
          },
          person: femalePerson, // 3rd generation
        },
      },
      person: malePerson, // 2nd generation
    },
    parent2Pedigree: {
      parents: {
        parent1Pedigree: {
          parents: {
            parent1Pedigree: {
              parents: {
                parent1Pedigree: {
                  person: malePerson, // 5th generation
                },
                parent2Pedigree: {
                  person: femalePerson, // 5th generation
                },
              },
              person: malePerson, // 4th generation
            },
            parent2Pedigree: {
              parents: {
                parent1Pedigree: {
                  person: malePerson, // 5th generation
                },
                parent2Pedigree: {
                  person: femalePerson, // 5th generation
                },
              },
              person: femalePerson, // 4th generation
            },
          },
          person: malePerson, // 3rd generation
        },
        parent2Pedigree: {
          parents: {
            parent1Pedigree: {
              parents: {
                parent1Pedigree: {
                  person: malePerson, // 5th generation
                },
                parent2Pedigree: {
                  person: femalePerson, // 5th generation
                },
              },
              person: malePerson, // 4th generation
            },
            parent2Pedigree: {
              parents: {
                parent1Pedigree: {
                  person: malePerson, // 5th generation
                },
                parent2Pedigree: {
                  person: femalePerson, // 5th generation
                },
              },
              person: femalePerson, // 4th generation
            },
          },
          person: femalePerson, // 3rd generation
        },
      },
      person: femalePerson, // 2nd generation
    },
  },
  person: unknownPerson, // The SELECTED person, 1st generation
})
